import React from 'react';
import styled from 'styled-components';
import GenericModal from './GenericModal';

const WalletAddressContainer = styled.div`
  font-size: 16px;
  margin-bottom: 20px;
  word-break: break-all;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center; /* Ensure content within is centered if it wraps */
`;

const CopyButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 18px; /* Slightly larger for better tap target */
  padding: 5px;
  color: #007bff; /* Standard link color for actions */

  &:hover {
    opacity: 0.7;
  }
`;

const DisconnectButton = styled.button`
  background-color: #000;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  padding: 15px;
  width: 100%;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #333;
  }
`;

const WalletModal = ({ isOpen, onClose, walletAddress, onDisconnect }) => {
  const handleCopyToClipboard = () => {
    if (navigator.clipboard && walletAddress) {
      navigator.clipboard.writeText(walletAddress);
      // Optionally, provide user feedback (e.g., toast message)
    }
  };

  return (
    <GenericModal
      isOpen={isOpen}
      onClose={onClose}
      title="Wallet"
      zIndex={1000000}
      containerMaxWidth="350px"
      contentPadding="20px" // Standard padding
    >
      {walletAddress ? (
        <>
          <WalletAddressContainer>
            {`${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}`}
            <CopyButton onClick={handleCopyToClipboard} title="Copy address">
              📋
            </CopyButton>
          </WalletAddressContainer>
          <DisconnectButton onClick={onDisconnect}>Disconnect</DisconnectButton>
        </>
      ) : (
        <p>No wallet connected.</p> // Fallback content
      )}
    </GenericModal>
  );
};

export default WalletModal;
